const grassA = {
  grassA1: "hsla(120, 94.9%, 38.7%, 0.016)",
  grassA2: "hsla(120, 94.9%, 38.7%, 0.048)",
  grassA3: "hsla(120, 98.0%, 35.5%, 0.079)",
  grassA4: "hsla(120, 98.7%, 31.5%, 0.126)",
  grassA5: "hsla(122, 98.5%, 29.9%, 0.193)",
  grassA6: "hsla(125, 99.2%, 27.9%, 0.283)",
  grassA7: "hsla(125, 99.9%, 27.0%, 0.408)",
  grassA8: "hsla(131, 100%, 27.6%, 0.604)",
  grassA9: "hsla(131, 99.7%, 26.3%, 0.726)",
  grassA10: "hsla(132, 99.9%, 24.0%, 0.761)",
  grassA11: "hsla(133, 99.5%, 19.5%, 0.840)",
  grassA12: "hsla(128, 98.0%, 4.9%, 0.895)"
};
export { grassA };
//# sourceMappingURL=grassA.mjs.map
